// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__19q87","center":"Spinner_center__26V4Z"};